import React, { useState, useEffect } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Graticule,
} from "react-simple-maps";
import { scaleLinear } from "d3-scale";
import { csv } from "d3-fetch";
import "./UsaMapCharts.css";
import Colors from "../assets/Colors";

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const colorScale = scaleLinear()
  .domain([0.29, 0.68])
  .range(["#ffedea", "#ff5233"]);

const MapChart = ({ setTooltipContent }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    // https://www.bls.gov/lau/
    csv("/unemployment-by-county-2017.csv").then((counties) => {
      setData(counties);
    });
  }, []);

  return (
    <>
      <ComposableMap data-tip="" projection="geoAlbersUsa">
        <Graticule stroke={Colors.neutralShadesOfGainsboro} />
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const cur = data.find((s) => s.id === geo.id);
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={Colors.mainBlue}
                  onMouseEnter={() => {
                    setTooltipContent({
                      state: geo.properties.name,
                      students: 230,
                      coaches: 100,
                    });
                  }}
                  onMouseLeave={() => {
                    setTooltipContent({});
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
    </>
  );
};

export default MapChart;
